import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminRoute from './components/AdminRoute';
import Teams from './pages/admin/Teams';
import Groups from './pages/admin/Groups';
import Matches from './pages/admin/Matches';
import Users from './pages/admin/Users';
import Points from './pages/admin/Points';
import BetMatches from './pages/bets/Matches';
import GeneralBets from './pages/bets/GeneralBets';
import KnockoutBets from './pages/bets/KnockoutBets';
import GroupBets from './pages/bets/GroupBets';
import GeneralAdminPage from './pages/admin/General';
import TournamentStats from './pages/TournamentStats';
import FunFacts from './pages/FunFacts';
import GeneralBetsSummaryPage from './pages/GeneralBetsSummary';
import UsersGeneralBetsPage from './pages/UsersGeneralBets';
import SideBets from './pages/SideBets';
import Leaderboard from './pages/Leaderboard';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import Contact from './pages/Contact';
import './App.css';

function App() {
  const { isAuthenticated, isLoading } = useAuth();
  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    if (!isLoading) setIsInitialized(true);
  }, [isLoading]);

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <div dir="rtl">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/profile"
          element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
        />
        <Route
          path="/dashboard/*"
          element={
            isAuthenticated ? <Dashboard /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/leaderboard"
          element={
            isAuthenticated ? <Leaderboard /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/bets/matches" 
          element={
            isAuthenticated ? <BetMatches /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/bets/general" 
          element={
            isAuthenticated ? <GeneralBets /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/bets/knockout" 
          element={
            isAuthenticated ? <KnockoutBets /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/bets/groups" 
          element={
            isAuthenticated ? <GroupBets /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/tournament-stats" 
          element={
            isAuthenticated ? <TournamentStats /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/tournament-stats/general-bets-summary" 
          element={
            isAuthenticated ? <GeneralBetsSummaryPage /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/tournament-stats/users-general-bets" 
          element={
            isAuthenticated ? <UsersGeneralBetsPage /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/fun-facts"
          element={
            isAuthenticated ? <FunFacts /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/side-bets"
          element={
            isAuthenticated ? <SideBets /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/contact"
          element={
            isAuthenticated ? <Contact /> : <Navigate to="/login" />
          }
        />
        <Route 
          path="/admin/teams" 
          element={
            <AdminRoute>
              <Teams />
            </AdminRoute>
          }
        />
        <Route 
          path="/admin/groups" 
          element={
            <AdminRoute>
              <Groups />
            </AdminRoute>
          }
        />
        <Route 
          path="/admin/matches" 
          element={
            <AdminRoute>
              <Matches />
            </AdminRoute>
          }
        />
        <Route 
          path="/admin/users" 
          element={
            <AdminRoute>
              <Users />
            </AdminRoute>
          }
        />
        <Route 
          path="/admin/points" 
          element={
            <AdminRoute>
              <Points />
            </AdminRoute>
          }
        />
        <Route 
          path="/admin/general" 
          element={
            <AdminRoute>
              <GeneralAdminPage />
            </AdminRoute>
          }
        />
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
      </Routes>
    </div>
  );
}

export default App; 